import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import * as moment from 'moment';

@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.css']
})
export class AnnouncementsComponent implements OnInit {
  @ViewChild('addEditAnnouncementModal') addEditAnnouncementModal: TemplateRef<any>;
  public modalReference: NgbModalRef;
  announcements;
  errorMessage;
  newAnnouncement;
  editAnnouncementFlag;

  constructor(private modal: NgbModal) { }

  getAnnouncements(): void {
    if (!localStorage.hasOwnProperty('announcements')) {
      localStorage.setItem('announcements', '[]');
    }
    this.announcements = JSON.parse(localStorage.getItem('announcements'));
    if (this.announcements.length <= 0) {
      this.errorMessage = 'There is no data available for announcements';
    }
    this.newAnnouncement = {};
  }

  openAddAnnouncementModal(): void {
    this.modalReference = this.modal.open(this.addEditAnnouncementModal, {size: 'lg', backdrop: 'static', keyboard: false});
  }

  openEditAnnouncementModal(announcement): void {
    this.editAnnouncementFlag = true;
    this.newAnnouncement = announcement;
    this.modalReference = this.modal.open(this.addEditAnnouncementModal, {size: 'lg', backdrop: 'static', keyboard: false});
  }

  addEditAnnouncement(): void {
    if (this.editAnnouncementFlag === true) {
      this.editAnnouncement();
    } else {
      this.addAnnouncement();
    }
  }

  addAnnouncement(): void {
    const that = this;
    Swal({
      title: 'confirm',
      type: 'question',
      text: 'Do you want to add this announcement?',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#5cb85c',
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.newAnnouncement.date = moment(new Date()).format('DD-MMM-YYYY');
          that.announcements.push(that.newAnnouncement);
          localStorage.setItem('announcements', JSON.stringify(that.announcements));
          resolve(true);
        });
      },
      allowOutsideClick: false,
    }).then(function (result) {
      if (result.value === true) {
        that.getAnnouncements();
        Swal({
          title: 'Success',
          type: 'success',
          width: 600,
          padding: 80,
          showCancelButton: false,
          showConfirmButton: true,
          html: '<p>Announcement Added successfully.</p>',
        });
        that.closeModal();
      }
    }, function (cancel) {
      console.log(cancel);
    }).catch(function (error) {
      console.log(error);
    });
  }

  editAnnouncement(): void {
    const that = this;
    Swal({
      title: 'confirm',
      type: 'question',
      text: 'Do you want to edit this announcement?',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#5cb85c',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          localStorage.setItem('announcements', JSON.stringify(that.announcements));
          resolve(true);
        });
      },
      allowOutsideClick: false,
    }).then(function (result) {
      if (result.value === true) {
        that.getAnnouncements();
        Swal({
          title: 'Success',
          type: 'success',
          html: '<p>Announcement Modified successfully.</p>',
        });
        that.closeModal();
      }
    }, function (cancel) {
      console.log(cancel);
    }).catch(function (error) {
      console.log(error);
    });
  }

  clearAnnouncements(): void {
    const that = this;
    Swal({
      title: 'confirm',
      type: 'question',
      text: 'Do you want to clear all announcements?',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#5cb85c',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      preConfirm: function() {
        return new Promise(function (resolve, reject) {
          localStorage.setItem('announcements', '[]');
          resolve(true);
        });
      },
      allowOutsideClick: false
    }).then(function (result) {
      if (result.value === true) {
        that.getAnnouncements();
        Swal({
          title: 'Success',
          type: 'success',
          width: 600,
          padding: 80,
          showCancelButton: false,
          showConfirmButton: true,
          html: '<p>Successfully cleared all announcements.</p>',
        });
      }
    }, function (cancel) {
      console.log(cancel);
    }).catch(function (error) {
      console.log(error);
    });
  }

  deleteAnnouncement(announcement): void {
    const that = this;
    Swal({
      title: 'confirm',
      type: 'question',
      text: 'Do you want to clear this announcement?',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#5cb85c',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      preConfirm: function() {
        return new Promise(function (resolve, reject) {
          const index = that.announcements.indexOf(announcement);
          that.announcements.splice(index, 1);
          localStorage.setItem('announcements', JSON.stringify(that.announcements));
          resolve(true);
        });
      },
      allowOutsideClick: false
    }).then(function (result) {
      if (result.value === true) {
        that.getAnnouncements();
        Swal({
          title: 'Success',
          type: 'success',
          width: 600,
          padding: 80,
          showCancelButton: false,
          showConfirmButton: true,
          html: '<p>Successfully cleared the announcements.</p>',
        });
      }
    }, function (cancel) {
      console.log(cancel);
    }).catch(function (error) {
      console.log(error);
    });
  }

  getDate(date): string {
    if (date === undefined || date === null || date === '' || date === 'undefined') {
      return '';
    }
    return moment(date).format('Do MMM YYYY');
  }

  closeModal(): void {
    this.newAnnouncement = {};
    this.editAnnouncementFlag = false;
    this.modalReference.close();
  }

  ngOnInit() {
    this.getAnnouncements();
  }

}
